import React from "react";

function InternetNotWorking() {

    return (
        <div className="card mb-3">
            <div className="card-body">
                <h6 className="fw-bold mb-3 text-danger">Internet Not Working</h6>
                <p>Vivamus blandit, odio eget tristique volutpat, eros lectus auctor lorem, vitae sagittis sapien mauris interdum ex. Donec eu eleifend massa. Donec viverra, ex ut euismod hendrerit, nunc nisi cursus est,
                    nec scelerisque lorem erat vel nunc. Duis non urna ornare, commodo felis ac, fringilla tortor. Nulla dui libero, dignissim et eros id, elementum rutrum risus</p>
                <p>Vivamus blandit, odio eget tristique volutpat, eros lectus auctor lorem, vitae sagittis sapien mauris interdum ex. Donec eu eleifend massa. Donec viverra, ex ut euismod hendrerit, nunc nisi cursus est, nec scelerisque lorem erat vel nunc. Duis non urna ornare,
                    commodo felis ac, fringilla tortor. Nulla dui libero, dignissim et eros id, elementum rutrum risus</p>
            </div>
        </div>
    )
}


export default InternetNotWorking;